import {useMemo} from "react"
import {BACKEND_APIS} from "@constants"

const __isUrlEncoded = url => /%[0-9A-Fa-f]{2}/.test(url)

export default function useProxiedImage(url) {
  return useMemo(() => {
    if (!url) return { decodedURL: "", isEncoded: false, imageResourceURL: "", proxyURL: "" }

    const isEncoded = __isUrlEncoded(url)
    let decodedURL = url
    if (isEncoded) {
      try {
        decodedURL = decodeURIComponent(url)
      } catch (e) {
        decodedURL = url
      }
    }

    // Proxy URL (server-side fetch). Kept as a fallback for the rare CDN that still blocks a
    // no-referrer direct hit, or http URLs that would be mixed-content on our https app.
    const proxyURL = decodedURL
      ? `${BACKEND_APIS.BACKEND}/sku/image-resource?url=${encodeURIComponent(decodedURL)}`
      : ""

    // Primary: load straight from the CDN. The app sets <meta name="referrer" content="no-referrer">
    // so no Referer is sent, dodging hotlink bans (the reason the proxy existed) without the extra
    // hop. http URLs (~0.3%) are upgraded to https to avoid mixed-content; if that 404s the
    // consumer falls back to proxyURL via onError.
    let directURL = decodedURL
    if (directURL.startsWith("http://")) {
      directURL = "https://" + directURL.slice("http://".length)
    }

    // imageResourceURL stays the field every consumer already uses as <img src>, now pointing direct.
    return { decodedURL, isEncoded, imageResourceURL: directURL, proxyURL }
  }, [url])
}
